/**
 * @desc 全局下载订单
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(body: defs.walmart.AllOrdersRequest, options?: any) {
  return updateResponse(
    http(URL + `/walmart/walmartOrder/downloadOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
